<template>
  <nav class="navbar">
    <div class="navbar-brand">
      <router-link
        class="navbar-item"
        :to="{ name: 'orders' }"
        @click.native="closeMenu()"
      >
        <h1 class="title is-4">Rikuso</h1>
      </router-link>
      <div
        class="navbar-burger burger"
        :class="{ 'is-active': menuActive }"
        @click="toggleMenu()"
        data-target="navbarTransparent"
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
    <div
      id="navbarTransparent"
      class="navbar-menu"
      :class="{ 'is-active': menuActive }"
    >
      <div class="navbar-start">
        <router-link
          class="navbar-item"
          :to="{ name: 'orders' }"
          @click.native="closeMenu()"
          exact-active-class="is-active"
          >Orders({{ this.$store.state.ordersCount }})</router-link
        >
        <router-link
          class="navbar-item"
          exact-active-class="is-active"
          :to="{ name: 'booking' }"
          @click.native="closeMenu()"
          >Booking({{ this.$store.getters.completedItemCount }})</router-link
        >
        <router-link
          class="navbar-item"
          exact-active-class="is-active"
          :to="{ name: 'booked' }"
          @click.native="closeMenu()"
          >Booked</router-link
        >
        <!-- Start QuocNV 29092023 add new screen  -->
        <router-link
          class="navbar-item"
          exact-active-class="is-active"
          :to="{ name: 'estimation' }"
          @click.native="closeMenu()"
          >Estimation/Price Update</router-link
        >
        <!-- End QuocNV 29092023 add new screen  -->
      </div>

      <div class="group-btn-link">
            <button @click="_openSystemRequest()" type="button"
                class="control-btn-link bgr-doc">
                <span>
                    <img src="../assets/meyasubako-white.svg" width="20" height="20">
                    システム質問・改善リクエスト
                </span>
            </button>
            <button @click="_openAnswerRequest()" type="button"
                class="control-btn-link bgr-sheet">
                <span>
                    <img src="../assets/meyasubako-white.svg" width="20" height="20">
                    リクエストに対する対応/回答
                </span>
            </button>
      </div>

      <div class="navbar-end">
        <div
          class="navbar-item is-flex"
          style="gap: 1rem; justify-content: center"
        >
          <div class="image is-32x32">
            <img class="is-rounded" :src="user.photoURL" />
          </div>
          <div style="padding-top: 0.1rem">
            {{ user.displayName }}
          </div>
          <button
            type="button"
            class="button is-small is-info is-outlined"
            @click="doLogout"
          >
            Sign out
          </button>
        </div>
      </div>
    </div>
  </nav>
</template>
<script>
import session from '@/repositories/session';
export default {
 
  data() {
    return {
      menuActive: false,
    };
  },
  computed: {
    incompleteItemCount() {
      return this.$store.state.ordersCount;
    },
    completedItemCount() {
      return this.$store.getters.completedItemCount;
    },
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    closeMenu() {
      this.menuActive = false;
    },
    toggleMenu() {
      this.menuActive = !this.menuActive;
    },
    doLogout() {
      session.logout();
      this.$router.push({ name: 'login' });
    },
    _openSystemRequest() {
      const windowWidth = 657;
      const windowHeight = 620;
      const xPos = screen['availLeft'] + screen.availWidth - (windowWidth + 15);
      const yPos = 5;
      const myWindow = window.open(process.env.VUE_APP_SYSTEM_REQUEST_URL,'', 'location=no,menubar=no,resizable=no,status=no,titlebar=no,toolbar=no,directories=yes,width=' + windowWidth + ',height=' + windowHeight + ',left=' + xPos + ',top=' + yPos);
      myWindow.focus();
      },
    _openAnswerRequest() {
      const myWindow = window.open(process.env.VUE_APP_ANSWER_REQUEST_URL,'_blank');
      myWindow.focus();
    }
  },
};
</script>
<style scoped>
.group-btn-link{
  margin: auto;
}
.control-btn-link{
  height: 30px;
  border: none;
  border-radius: 15px;
  color: #ffffff;
  cursor: pointer;
}
.control-btn-link  span{
  display: flex;
  justify-content: center;
  align-items: center;   
}
.bgr-doc{
  margin-right: 20px;
  background-color: #007bff;
}
.bgr-sheet{
  background-color: #5bc0de;
}
</style>